import React from 'react'
import _ from 'lodash'
import {
    addPart as addComparePart,
    removePart as removeComparePart,
    selectCompareParts
} from '../table/compareSlice'
import { useSelector, useDispatch } from 'react-redux'
import {Checkbox as CheckboxAntd} from "antd";
import isAuthorized from "../../utils/constants/isAuthorized";
import isProd from "../../utils/constants/isProd";
import searchParams from "../../utils/constants/searchParams";
import axios from "axios";
import { fillHeaderCompareSvg } from "./CompareFunctions";
import { redColor } from "../../utils/constants/compareParts";

const CompareCheckbox = ({ part_id, hash, article, brand }) => {
    const dispatch = useDispatch()
    const compareParts = useSelector(selectCompareParts)

    const partInCompare = _.find(compareParts, { hash })
    const isPartInCompare = typeof partInCompare !== 'undefined'

    const addComparePartHandler = (hash, part_id, article, brand) => (e) => {
        if(_.size(compareParts)<4 && isAuthorized) {
            if (isProd) {
                const ajaxCompareUrl = '/auto/search/compare/ajax.php'
                const data = new URLSearchParams()
                data.append('action', 'add_to_compare')
                data.append('part_id', part_id)
                data.append('article', article)
                data.append('brand_title', brand)
                data.append('search_id', searchParams.QUERY.toUpperCase())

                axios
                    .post(ajaxCompareUrl, data)
                    .then((response) => {
                        const isSuccess = response.status === 200 && response.data.success === true;

                        if (isSuccess) {
                            fillHeaderCompareSvg(redColor)
                        }
                    })
            }

            dispatch(addComparePart({hash: hash, article: article, brand: brand, part_id: part_id}))
        }
    }

    const removeComparePartHandler = (id, hash) => (e) => {
        if (isProd) {
            const ajaxCompareUrl = '/auto/search/compare/ajax.php'
            const data = new URLSearchParams()
            data.append('action', 'remove_from_compare')
            data.append('article', article)
            data.append('brand_title', brand)

            axios
                .post(ajaxCompareUrl, data)
                .then(() => {
                    if (compareParts.length === 1) {
                        fillHeaderCompareSvg()
                    }
                })
        }

        dispatch(removeComparePart({hash: hash}))
    }

    return (
        <div
            className="add-compare__wrapper"
            onClick={
                isPartInCompare
                    ? removeComparePartHandler(partInCompare['id'], hash)
                    : addComparePartHandler(hash, part_id, article, brand)
            }
        >
            <CheckboxAntd className="checkbox" key={'1'} value={'1'} checked={isPartInCompare} >
                <span className="checkbox__add-compare">Добавить<br />к сравнению</span>
            </CheckboxAntd>
        </div>
    )
}

export default CompareCheckbox
